import React, { useEffect, useState, useRef, useContext } from 'react';
import { IonItem, IonButton, IonSlides, IonGrid, IonTabs, IonTab, IonTabBar, IonTabButton, IonToolbar, IonTitle, IonContent, IonHeader, IonLabel, IonRouterOutlet, IonFooter, IonCard, IonModal } from '@ionic/react';
import { IonSlide, IonRow, IonCol, IonImg } from '@ionic/react';
import '../css/zPublic.css';

import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';
import { Reservation_EnterBookingInfo } from './Reservation_EnterBookingInfo_locals';

export function Enlarge_Image (props) {

        alert("IN ENLARGE");

        let authMerchant_objects = useContext(Auth_MerchantID_context);


        let [inputReservationInfoModal, setInputReservationInfoModal] = useState(false);

        let [roomID, setRoomID] = useState(props.data.roomID);

        alert("IN ENLARGE 2");


            return (
                <React.Fragment>
                <IonModal isOpen={true}>
                    <IonContent>
                        <div 
                        style={{ 
                            display: 'flex', 
                            justifyContent: 'center', 
                            alignItems: 'center', 
                            height: '100%' 
                        }}
                        >
                        <IonImg 
                            src={props.data.image} 
                            style={{ 
                            width: '95%', 
                            height: 'auto', 
                            cursor: 'pointer' 
                            }} 
                        />
                        </div>
                <IonFooter class='appFooter'>
                    <IonButton size='smaller' onClick={() => setInputReservationInfoModal(true)}> BOOK ROOM </IonButton>
                    <IonButton size='smaller' onClick={() => props.closeModal()}> Close </IonButton>

                </IonFooter>

                {inputReservationInfoModal == true &&   <Reservation_EnterBookingInfo openModal={ inputReservationInfoModal } closeModal={() => setInputReservationInfoModal(false)}  tracker={"PUBLIC_74701"} data={{
                        companyID: props.data.companyId,
                        roomID: roomID, 
                        roomSalePrice: '',
                        }}></Reservation_EnterBookingInfo> }

                    </IonContent>
                </IonModal>
                        
            </React.Fragment>
    
            )
        //}


    }
